<ng-container *ngIf="model">
  <div
    *ngIf="borderRadius"
    [ngClass]="{
      rectangle: borderRadius === 'full',
      'rectangle-radius-top': borderRadius === 'top',
      'rectangle-radius-bottom': borderRadius === 'bottom',
      'rectangle-no-radius': borderRadius === 'none'
    }"
  ></div>
  <result-rich-text-section-elements
    [items]="model.elements"
    [highlights]="highlights"
    (invoke)="invoke.emit($event)"
  ></result-rich-text-section-elements>
</ng-container>
